import React from 'react'
import { AssignmentRuleDTO } from '@user/store/leadAssignmentRule'
import { useTheme } from '@mui/material/styles'
import Box from '@mui/material/Box'
import { LeadAssignmentRuleItem } from '../LeadAssignmentRuleItem'
import Stack from '@mui/material/Stack'
import { getStyles } from '../../hooks/useStyles'

type Props = {
  assignment: AssignmentRuleDTO
  onClick: (id?: number) => void
  onView: (id?: number) => void
  index: number
}

export function LeadAssignmentRuleDraggableCard(props: Props) {
  const { assignment, onClick, onView, index } = props
  const styles = getStyles(useTheme())
  return (
    <Box
      sx={{
        ...styles.draggable,
        marginBottom: 0,
        marginTop: 0,
        cursor: 'grab',
      }}
    >
      <Box sx={styles.row}>
        <Box sx={styles.actionContainer}>
          <Stack direction="row" flexGrow={0}>
            <LeadAssignmentRuleItem
              onClick={onClick}
              onView={onView}
              assignment={assignment}
              key={`assignmentRule_${index}`}
            />
          </Stack>
        </Box>
      </Box>
    </Box>
  )
}
